import React from "react";
import { BarChart3Icon, CameraIcon, GitForkIcon, LayoutGridIcon, MapIcon } from "lucide-react";
import { tools } from "../../data/content";
import { CtaButton } from "../CtaButton";
const icons = {
  map: MapIcon,
  grid: LayoutGridIcon,
  tree: GitForkIcon,
  chart: BarChart3Icon,
  camera: CameraIcon
};
export function Tools() {
  return <section className="bg-navy-950 px-5 py-16 text-white md:py-24" data-id="element-270" data-mp="2di6c246vondv">
      <div className="mx-auto max-w-3xl" data-id="element-271" data-mp="28kekxce255aq">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight md:text-5xl" data-id="element-272" data-mp="28l69w4d5g4s1">
          You'll also get <em className="text-gold-400" data-id="element-273" data-mp="1ytjqhkqnqze7">5 professional tools</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] text-navy-100" data-id="element-274" data-mp="1yrh21555lebl">Immediate access, ready to use digitally or in print.</p>

        <ul className="mt-10 divide-y divide-white/10 rounded-3xl bg-navy-900 ring-1 ring-white/10" data-id="element-275" data-mp="1ptdds12sa3g3">
          {tools.map(t => {
          const Icon = icons[t.icon];
          return <li key={t.title} className="flex gap-4 p-5 md:p-6" data-id="element-276" data-mp="158y1o2zkniz6">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold-400 text-navy-950" data-id="element-277" data-mp="157mx40yay770">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-278" data-mp="w91j8j3rzgck" />
                </span>
                <div data-id="element-279" data-mp="10ad0o1chwv9o">
                  <h3 className="text-lg font-bold text-white" data-id="element-280" data-mp="109v391e3kb06">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-navy-100" data-id="element-281" data-mp="1nzxu5e69zax7">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-xl text-center font-serif text-xl italic text-navy-100 md:text-2xl" data-id="element-282" data-mp="1sy93zowkllff">
          Whatever educational case you're studying, you'll have a clear structure to analyze, document, and review it.
        </p>

        <CtaButton className="mt-8" tone="dark" label="I want the complete system" data-id="element-283" data-mp="3jkupwja0jlm" />
      </div>
    </section>;
}